import { useEffect, useState } from "react";
import { TournamentItmResponse } from "../../../../../api/pub-tournament";
import Pagination from "../../../../../components/web/Pagination";
import { PubType } from "../../../../../api/types";
import { TournamentType } from "../../../../../dataset";
import {
  TournamentItmBack,
  TournamentItmItem,
  TournamentItmTable,
  TournamentItmTableHeader,
  TournamentItmWrapper,
  TournamentTableItemWrapper,
} from "./style";

interface TournamentStateItmProps {
  itm: TournamentItmResponse[];
  pubType: PubType;
  tournamentType: TournamentType;
}
const TournamentStateItm = ({
  itm,
  pubType,
  tournamentType,
}: TournamentStateItmProps) => {
  const size = 7;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [list, setList] = useState<TournamentItmResponse[]>([]);

  useEffect(() => {
    setTotalPages(Math.max(1, Math.ceil(itm.length / size)));
    setList(itm.slice((currentPage - 1) * size, currentPage * size));
  }, [itm]);

  useEffect(() => {
    setList(itm.slice((currentPage - 1) * size, currentPage * size));
  }, [currentPage]);

  const handelPrize = (item: TournamentItmResponse) => {
    if (tournamentType === TournamentType.TimeAttack) {
      if (item.stack) return item.stack.toLocaleString();
      return item.prize.toLocaleString();
    }
    if (pubType !== "RUNNER") {
      if (item.isSubPrize) {
        return item.subPrize;
      }
      return item.prize.toLocaleString();
    }
    if (tournamentType === TournamentType.Tournament)
      return item.prize.toLocaleString();
    if (/^\d+$/.test(item.subPrize)) {
      return Number(item.subPrize).toLocaleString();
    }
    return item.subPrize;
  };

  const getHeaderText = () => {
    if (tournamentType === TournamentType.TimeAttack) {
      if (list.some((item) => item.stack)) return "바이인칩";
    }
    return "ITM 순위";
  };

  return (
    <TournamentItmWrapper>
      <div className="header">{getHeaderText()}</div>
      <TournamentItmBack isItm={true}>
        <TournamentItmTable isHeight={totalPages > 1} isItm={true}>
          <TournamentTableItemWrapper>
            {list.map((item, index) => (
              <TournamentItmItem key={index}>
                <div className="info">
                  <div className="rank">{item.rank}위</div>
                  <div className="user">{item.nickname}</div>
                </div>
                <div className="item">{handelPrize(item)}</div>
              </TournamentItmItem>
            ))}
          </TournamentTableItemWrapper>
        </TournamentItmTable>
        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            size={22}
          ></Pagination>
        )}
      </TournamentItmBack>
    </TournamentItmWrapper>
  );
};
export default TournamentStateItm;
